module.exports = __webpack_public_path__ + "static/media/ic_antonaya.e623eb95.png";